<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 党建引领轮播图 -->
    <PartyBanner></PartyBanner>
    <!-- 党建要闻详情页 -->
    <PartyDetails :newsId="newsId"></PartyDetails>
    <!-- 底部导航 -->
    <BottomNav></BottomNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/pc/components/TopNav.vue";
import BottomNav from "../../../../components/pc/components/BottomNav.vue";
import PartyBanner from "../../../../components/pc/Party/PartyBanner.vue";
import PartyDetails from '../../../../components/pc/Party/PartyDetails.vue'

export default {
  setup() {
    return reactive({
        newsId: 1
    });
  },
  components: {
    TopNav,
    BottomNav,
    PartyBanner,
    PartyDetails
  },
  created() {
    this.newsId = this.$route.query.id;
  },
};
</script>

<style scoped>
</style>
